import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Const } from '@app/shared';
import { EndpointService } from '@app/core';

export interface systemUserTask {
  id: number;
  nombre: string;
  actividad: string;
  fecha_activacion: string;
  id_tramite: number;
  nombre_tramite: string;
  tramite_expediente: number;
  tramite_radicado_expediente?: any;
  tramite_radicado_solicitud: string;
  categoria: number;
  proceso: number;
  microproceso?: any;
  secundaria?: any;
  select?: boolean;
}

@Injectable()
export class UserInstanceProcedureService {
  PATH_SERVICES = Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.services;
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  /**
   * Consulta la información necesaria para generar el calendario de tramites.
   *
   * @param {number} idUsuario
   * @returns {Observable<any>}
   * @memberof UserInstanceProcedure
   */
  getDataCalendar(idUsuario: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().get<any>(this.api.get('utilitiesRequestedUser', [idUsuario])).subscribe(
        data => {
          resolve(data);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error(`No se pudó consultar la información del trámites del usuario`, 'Operación fallida');
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Consulta los usuarios del sistema.
   *
   * @param 
   * @returns {Observable<>}
   * @memberof UserInstanceProcedure
   */
  getSystemUsers(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(this.api.get('utilitiesRequestedUser')).subscribe(
        data => {
          resolve(data);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Reemplaza el usuario para los tramite ingresados
   *
   * @param
   * @return {*}  {Promise<Actividad>}
   * @memberof UserInstanceProcedure
   */
  replaceUser(user: any, procedures: any[], userReplace: any): Promise<boolean> {
    let message = 'Reasignación realizada con éxito';
    let list_process: any[] = [];
    procedures.forEach(pro => {
      list_process.push(pro.id);
    });
    let dataForm = {
      user_id: user,
      procedures: list_process,
      user_replace: userReplace
    }
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().post<any>(this.api.get('utilitiesRequestedUser'), dataForm).subscribe(
        data => {
          this.toastr.success(message, 'Operación exitosa')
          resolve(true);
        },
        err => {
          if(err.status !== 400 && err.status !== 403){
            this.toastr.error('Ha ocurrido un error al realizar la transacción', 'Error en la transacción')
          }
          reject(false);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/users-instance-procedure/shared/users-instance-procedure.service.ts